module.exports = __webpack_public_path__ + "static/media/favicon.1c496f04.ico";